/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointedIntermediaryViewModel
 */
export interface AppointedIntermediaryViewModel {
    /**
     * 
     * @type {string}
     * @memberof AppointedIntermediaryViewModel
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointedIntermediaryViewModel
     */
    nameAndSurname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointedIntermediaryViewModel
     */
    advising?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointedIntermediaryViewModel
     */
    servicing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointedIntermediaryViewModel
     */
    authorityLevel?: string;
}

/**
 * Check if a given object implements the AppointedIntermediaryViewModel interface.
 */
export function instanceOfAppointedIntermediaryViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppointedIntermediaryViewModelFromJSON(json: any): AppointedIntermediaryViewModel {
    return AppointedIntermediaryViewModelFromJSONTyped(json, false);
}

export function AppointedIntermediaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointedIntermediaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'Code') ? undefined : json['Code'],
        'nameAndSurname': !exists(json, 'NameAndSurname') ? undefined : json['NameAndSurname'],
        'advising': !exists(json, 'Advising') ? undefined : json['Advising'],
        'servicing': !exists(json, 'Servicing') ? undefined : json['Servicing'],
        'authorityLevel': !exists(json, 'AuthorityLevel') ? undefined : json['AuthorityLevel'],
    };
}

export function AppointedIntermediaryViewModelToJSON(value?: AppointedIntermediaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Code': value.code,
        'NameAndSurname': value.nameAndSurname,
        'Advising': value.advising,
        'Servicing': value.servicing,
        'AuthorityLevel': value.authorityLevel,
    };
}

